import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FUNCION_PLAN, planPorClave, tieneFuncion } from '../services/membresiaService';
import { EN_TIENDA, segunTienda } from '../utils/tienda';

// Muestra el contenido si el plan del negocio incluye `funcion`; si no, una
// tarjeta con candado que invita a subir de plan.
export function usePlan() {
  const { suscripcion } = useAuth();
  return {
    tiene: (funcion) => tieneFuncion(suscripcion, funcion),
    planNecesario: (funcion) => planPorClave(FUNCION_PLAN[funcion])?.nombre || 'superior',
  };
}

export default function SoloPlan({ funcion, titulo, onVerPlanes, children }) {
  const { tiene, planNecesario } = usePlan();
  if (tiene(funcion)) return children;
  return (
    <div className="k-card" style={{ padding: '16px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', background: '#FAF8FF', border: '1px dashed #C4B5FD' }}>
      <span style={{ fontSize: '22px' }}>🔒</span>
      <div style={{ flex: 1, minWidth: '200px' }}>
        <p style={{ margin: 0, fontWeight: 700, color: '#374151' }}>{titulo}</p>
        <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#6B7280' }}>{segunTienda(`Disponible desde el plan ${planNecesario(funcion)}.`, 'No está incluido en tu plan actual.')}</p>
      </div>
      {onVerPlanes && !EN_TIENDA && <button onClick={onVerPlanes} className="k-btn-soft">💎 Ver planes</button>}
    </div>
  );
}
